import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => {
  return (
    <SectionContainer
      id='app-delete-cta'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <Col
          medium={8}
          align='center'>
          <Typography
            component='h2'
            themeType='darkTheme'
            nextElement='typography'
            weight={600}>
            Need to <WidowBlock>delete your account&#63;</WidowBlock>
          </Typography>
          <Link
            id='delete-mobile-app-link'
            variant='buttonLinkPrimary'
            themeType='darkTheme'
            linkUrl='/help/delete/account/'
            ariaLabel='Instructions on how to delete the mobile app'
            isOutgoingLink>
            Delete your account
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
